import { Collapse as MuiCollapse } from '@mui/material';

export default MuiCollapse;
